
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer",
      function () {
        return require("private-next-pages/refer/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer"])
      });
    }
  